import React, { useLayoutEffect, useRef } from "react";
import { useWindowSize } from "react-use";
import {
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
  List as VirtualizedList,
  WindowScroller,
} from "react-virtualized";

import { Divider, Paper } from "@mui/material";

import { ApiRoutesItem } from "@/api/routes";
import { CabinsType } from "@/typings";

import ListItem from "./ListItem";

const List = (props: {
  data: ApiRoutesItem[];
  onClick: (
    v: ApiRoutesItem & {
      type: CabinsType;
    }
  ) => void;
}) => {
  const cacheRef = useRef(
    new CellMeasurerCache({
      fixedWidth: true,
      minHeight: 50,
    })
  );

  const { width: windowWidth } = useWindowSize();

  useLayoutEffect(() => {
    cacheRef.current.clearAll();
  }, [windowWidth]);

  return (
    <Paper elevation={1}>
      <WindowScroller scrollElement={window}>
        {({ height, isScrolling, registerChild, onChildScroll, scrollTop }) => (
          <AutoSizer disableHeight>
            {({ width }) => (
              // @ts-ignore
              <div ref={registerChild}>
                <VirtualizedList
                  ref={(el) => {
                    // @ts-ignore
                    window.listEl = el;
                  }}
                  autoHeight
                  isScrolling={isScrolling}
                  onScroll={onChildScroll}
                  scrollTop={scrollTop}
                  deferredMeasurementCache={cacheRef.current}
                  rowCount={props.data.length}
                  rowRenderer={({ index, key, parent, style }) => (
                    <CellMeasurer
                      cache={cacheRef.current}
                      columnIndex={0}
                      key={key}
                      rowIndex={index}
                      parent={parent}
                    >
                      {({ measure, registerChild }) => (
                        // @ts-ignore
                        <div ref={registerChild} style={style} key={index}>
                          <ListItem
                            onLoad={measure}
                            data={props.data[index]}
                            onClick={props.onClick}
                          />
                          {index < props.data.length - 1 ? <Divider /> : null}
                        </div>
                      )}
                    </CellMeasurer>
                  )}
                  width={width}
                  height={height}
                  rowHeight={cacheRef.current.rowHeight}
                  overscanColumnCount={0}
                />
              </div>
            )}
          </AutoSizer>
        )}
      </WindowScroller>
    </Paper>
  );
};

export default React.memo(List);
